import React from 'react';
import PropTypes from 'prop-types';

const KeyValueList = ({ data, className = '' }) => (
  <dl className={`key-value-list ${className}`}>
    {Object.entries(data).map(([key, value]) => (
      <div key={key}>
        <dt className="key-value-list__key">{key}</dt>
        <dd className="key-value-list__value">{value ?? 'Not available'}</dd>
      </div>
    ))}
  </dl>
);

KeyValueList.propTypes = {
  data: PropTypes.objectOf(PropTypes.node).isRequired,
  className: PropTypes.string,
};

export default KeyValueList;
